import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App';
import Config from './util/config';

const setup = (elementId: string): void => {
    const element: HTMLElement = document.getElementById(elementId);

    if (!element)
      return

    try {
        Config.setAll(JSON.parse(element.dataset['options']));
    } catch (err) {
        // JSON parse failed we don't care
    }

 
    ReactDOM.render(
        <App />,
        element
    );
}

export default {
    setup,
}

